<template>
  <div class="qrcode-modal" @click="hideQrcodeModal">
    <div class="bg"></div>
    <button class="close" @click="hideQrcodeModal">&nbsp;</button>
    <div class="qrcode">
      <h3>{{ title }}</h3>
      <div class="image-container" v-show="showQrcode">
        <qrcode :value="this.qrcodeValue" :options="{ width: 200 }"></qrcode>
      </div>
      <div class="notice" v-html="this.qrNotice" v-show="this.platform == 'android' || this.platform == 'ios'"></div>
      <div class="notice" style="text-align: center;" v-html="this.$t('qrcode_notice_for_desktop')" v-show="this.platform != 'android' && this.platform != 'ios'"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QrcodeModal",
  props: ["channel", "platform", "title", "showQrcode", "invitationCode"],
  data: function() {
    return {};
  },
  computed: {
    qrcodeValue: function() {
      let url = new URL(this.$pageUrl);
      if (this.channel) {
        url.searchParams.append('channel', this.channel);
      }
      if (this.invitationCode) {
        url.searchParams.append('source', this.invitationCode);
      }
      return url.toString();
    },
    qrNotice: function() {
      if (this.platform == 'ios' || this.platform == 'android') {
        return this.$t(`${this.platform}_qrcode_notice`)
      } else {
        return "";
      }

    }
  },
  methods: {
    hideQrcodeModal: function() {
      this.$emit("hideQrcodeModal");
    },
  },
  created: function() {},
};
</script>

<style lang="scss">
@import "../assets/style.scss";
.qrcode-modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
  .bg {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.9);
    position: fixed;
  }
  .qrcode {
    h3 {
      padding-bottom: 2rem;
    }
    .image-container {
      padding-bottom: 2rem;
    }
    max-width: 500px;
    z-index: 10;
    width: 100%;
    .notice {
      text-align: left;
      padding: 1rem 1rem;
      line-height: 1.4rem;
      width: 100%;
    }
  }
}
</style>
